import * as React from 'react';
import Link from '@mui/material/Link';

const HelloLink = () => (
  <Link color="inherit" href="mailto:hello@agoraip.co.uk">hello@agoraip.co.uk</Link>
);

export default HelloLink;